import React from "react";
import { Tooltip } from 'antd';
import styles from "./scss/unread.module.scss";
import _ from 'lodash';
import { useSelector } from "react-redux";
import { leftsideChats, initialStateModel } from "../../../models/model";
import ContactLists from "./contactlists";
import { URChatLeftSkeleton } from "../../../shared/widgets/skeletonLoading/chatLeftSkeleton";
import nodataChatleft from "../../../styles/images/noleftchatimg.svg";

/* const content = (
  <div className={styles.contactDetailsSec}>
    <img src={userimg} alt="" className={styles.userImg} />
    <div className={styles.userDt}>
      <p className={styles.userName}>Johnny Wade</p>
      <span className="icon_star"></span>
      <span className="icon_bellstroke"></span>
    </div>
    <div className={styles.actionIcon}>
      <span className="icon_call"></span>
      <span>Call</span>
      <span className="icon_chat"></span>
      <span>Chat</span>
      <span className="icon_meet"></span>
      <span>Meet</span>
    </div>
    <div className={styles.profileDt}>
      <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
        <div className={styles.leftsidetxt}>
          <p>Department</p>
               
        </div>
        <div className={styles.rightsidetxt}>
          <p>IT Department</p>
        </div>
      </div>
      <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
        <div className={styles.leftsidetxt}>
          <p>Extension</p>
        </div>
        <div className={styles.rightsidetxt}>
          <p>201</p>
        </div>
      </div>
      <div className={`${styles.rowFlex} `}>
        <div className={styles.leftsidetxt}>
          <p>My Numbers</p>
        </div>
        <div className={styles.rightsidetxt}>
          <div className={styles.phoneNumbrtxt}>
            <Tooltip placement="top" title="Company number"><p>02037827900</p></Tooltip>
            <Tooltip placement="top" title="UnifiedRing number"><p>01212190524</p></Tooltip>
            <Tooltip placement="top" title="Mobile number"><p>07574198622</p></Tooltip>
            <Tooltip placement="top" title="International number"><p>+4368860755414</p></Tooltip>
          </div>
        </div>
      </div>
      <div className={`${styles.rowFlex} `}>
        <div className={styles.leftsidetxt}>
          <p>Email Address</p>
        </div>
        <div className={styles.rightsidetxt}>
          <div className={styles.emailtxt}>
            <Tooltip placement="top" title="johnywade.johny.wa@vectone.com">
              <p>johnywade.johny.wa@vectone.com</p></Tooltip>
            <Tooltip placement="top" title="johnywade.12465@vectone.com"><p>johnywade.johny.wa@vectone.com</p></Tooltip>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.workingStatus}>
      <StatusTag className='statusTag bgGrey' name='Working remotely' />
      <span><img src={statusimg} alt="" /></span>
    </div>

  </div>
); */
// type RecentChatState={
//   limit:any;
//   offset:any;
// }

export default function UnreadContactLists(props:any) {
  const contactList: leftsideChats = useSelector((state: initialStateModel) => state.recentchatReducer);
  let {isUnreadLoader, unReadPageLoad, isUnreadPaginationStop} = contactList;
  
  // const [pagination, setPagination] =  useState<RecentChatState>({limit:20,offset:0});
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let {  contactReducer } = allReducer;
  let workContact = contactReducer?.workContactsnew;
  let teamContact = contactReducer?.teamContacsnew;
  const setFilteredLayer = ()=>{
    props.setFilteredLayer("default");
  };

  const handleScroll=(e:any)=>{
    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    if(bottom  && isUnreadPaginationStop){
    }
  };

  const filteredContacts = _.filter(props.defaultContacts.searchUnread, (value)=>{
    // console.log(value,"Contact 222--->", value);
    let contactsDetail = value.type===1? workContact[value.to]:teamContact["con"+value.chatId];
    return contactsDetail!==undefined;
  });

  const updateChatIndex = () => {
    props.updateChatIndex();
  }

  return (
    <>
    
              
            
      <div className={`fadeIn ${styles.unreadcontacts}`}>
        {/* <div className={styles.rightbartop}>
          <div className={styles.lefts}>
            Unread <b>{filteredContacts?.length}</b> 
          </div>
          <div className={styles.rights}>
            <Tooltip  mouseEnterDelay={0.5} placement="top" title="Close">
              <span className="icon_close" onClick={setFilteredLayer}></span></Tooltip>
          </div>
        </div> */}
        
      {filteredContacts?.length === 0 &&   <div className="nodataleftsidecenter unread">
                <div className="centerimg unreadcenter">
                <img src={nodataChatleft}
                />
                <h4>No Unread Chats</h4>
                <p onClick={setFilteredLayer}>Clear Filter</p>
                </div>
              </div>}
              {filteredContacts?.length > 0 &&   <div className={styles.unreadLeftScroll} onScroll={handleScroll}>
          <ContactLists isSearch={props.defaultContacts.isSearch}
            searchContactList={props.defaultContacts.searchUnread}   
            contactList={props.defaultContacts.searchUnread} 
            updateChatIndex={updateChatIndex}
            isLoader={isUnreadLoader} searchText="" pinnedList={props.defaultContacts}></ContactLists>
          { unReadPageLoad && ([1].map((item: any, index: any) => (
            <URChatLeftSkeleton width={100} key={index} />)))}
        </div>}
      </div>
    </>
  );
};

